import { Field } from '@base-ui/react/field';
import { Switch as BaseSwitch } from '@base-ui/react/switch';
import clsx from 'clsx';

export interface SwitchProps {
  description?: React.ReactNode;
  disabled?: boolean;
  label?: React.ReactNode;
  onChange?: (checked: boolean) => void;
  placement?: 'left' | 'right';
  value: boolean;
}

export function Switch({
  description,
  disabled,
  label,
  onChange,
  placement = 'left',
  value
}: SwitchProps) {
  return (
    <Field.Root
      disabled={disabled}
      className={clsx('flex justify-between gap-x-3', placement === 'right' && 'flex-row-reverse')}
    >
      <BaseSwitch.Root
        checked={value}
        disabled={disabled}
        nativeButton
        onCheckedChange={onChange}
        render={<button />}
        className="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:outline-hidden not-data-disabled:data-checked:bg-primary-600 data-disabled:bg-gray-100 not-data-disabled:data-unchecked:bg-gray-200 motion-reduce:transition-none"
      >
        <BaseSwitch.Thumb className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out data-checked:translate-x-5 data-unchecked:translate-x-0 motion-reduce:transition-none" />
      </BaseSwitch.Root>

      {!!(label || description) && (
        <div className="flex grow flex-col">
          {label && (
            <Field.Label
              render={<span />}
              nativeLabel={false}
              className="leading-6 font-medium text-gray-900"
            >
              {label}
            </Field.Label>
          )}
          {description && (
            <Field.Description className="text-gray-500">{description}</Field.Description>
          )}
        </div>
      )}
    </Field.Root>
  );
}
